// @flow

import React, { Fragment } from "react";
import className from "classnames";
import { Button, View, Text } from "@components";
import type { ColumnType } from "../../types";

type Props = {|
  column: ColumnType,
  className?: string,
|};

export const Column = (props: Props) => (
  <View name="Column">
    {(props.column.columnTitle || props.column.columnButtons) && (
      <View
        name="Column-1st-child"
        gap="3"
        separator={!props.column.data && "bottom"} // The subcolumns have their own separator and in order to not make x2 separators we are checking
        padding={[0, 0, 3, 0]}
        className={props.className}
      >
        <View direction="row" alignItems="center" justifyContent="space-between">
          {props.column.columnTitle && (
            <View>
              <h6 className="font-weight-bold">{props.column.columnTitle}</h6>
            </View>
          )}
          {props.column.columnButtons && (
            <View
              name="Column-columnButtons"
              alignItems="start"
              direction="row"
              justifyContent="space-between"
              className={props.column.verticalColumnButtons}
            >
              <View gap={3}>
                {props.column.columnButtons
                  .filter(button => !button.hidden)
                  .map(button => (
                    <Button
                      size="small"
                      key={button.text}
                      className={props.column.verticalColumnButtons}
                      color={button.color}
                      materialIcon={button.materialIcon}
                      onClick={button.onClick}
                    >
                      {button.text}
                    </Button>
                  ))}
              </View>
            </View>
          )}
        </View>
      </View>
    )}
    {!props.column.subColumns && (
      <View name="Column-subColumns">
        {props.column.data &&
          props.column.data.map((keyValue, index) => (
            <View
              minHeight={!keyValue[0] || !keyValue[1] ? 6 : 12}
              separator={"top"}
              name="Column-subColumns-1st-child"
              justifyContent="center"
              key={`data-${index}`}
              padding={[2, 0, 2, 0]}
            >
              <Text
                color={"charcoal"}
                className={props.column.rowsLabelClassName}
                text={keyValue[0]}
              />
              <Text className={props.column.rowsValueClassName} text={keyValue[1]} />
            </View>
          ))}
      </View>
    )}
  </View>
);

export default Column;
